import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mudeguoshenbao",
  "use": "icon-mudeguoshenbao-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-mudeguoshenbao\"><path d=\"M8 14.719A6.726 6.726 0 011.281 8a.469.469 0 11.938 0A5.788 5.788 0 008 13.781 5.788 5.788 0 0013.781 8a.469.469 0 01.938 0A6.726 6.726 0 018 14.719zm0 0a.469.469 0 01-.469-.469v-7.5a.469.469 0 11.938 0v7.5c0 .259-.21.469-.469.469zm0-7.5A2.972 2.972 0 015.031 4.25 2.972 2.972 0 018 1.281a2.972 2.972 0 012.969 2.969A2.972 2.972 0 018 7.219zm0-5c-1.12 0-2.031.911-2.031 2.031S6.88 6.281 8 6.281s2.031-.911 2.031-2.031S9.12 2.219 8 2.219zm2.778 7.222H5.222a.469.469 0 010-.937h5.556a.469.469 0 010 .937z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/mudeguoshenbao.svg
// module id = 499
// module chunks = 4